<div class="grid-container">
<div class="content-with-elevation  content">
  <div class="grid-x">
    <div class="column small-12 medium-12 large-4 login-form content content-with-elevation">
      <common-alerts [successMessage]="successMessage" [errorMessage]="errorMessage"></common-alerts>
      <form (ngSubmit)="onSubmit()" [formGroup]="loginForm" autocomplete="off" novalidate>

        <div class="grid-x ">
          <div class="small-12 large-12 medium-12">
            <div class="grid-x">
              <div class="cell medium-12 large-12 small-12"><input formControlName="loginName" placeholder="Username"
                                                                   class="input-group-custom" required>
                <div class="input-field-error" *ngIf="loginForm.get('loginName').errors?.invalidFormat">
                  Use your RZMS username, not email address
                </div>

              </div>
            </div>
            <div class="grid-x" style="margin-top: 10px">
              <div class="cell medium-12 large-12 small-12"><input type="password" formControlName="password" placeholder="Password"
                                                                   class="input-group-custom">

              </div>
            </div>
          </div>
        </div>

        <div class="grid-x button-placement-right">
          <button class="iana-button" type="submit" [disabled]="!loginForm.valid">Login</button>
        </div>

      </form>
    </div>
    <div class="column small-12 medium-12 large-1">
      &nbsp;
    </div>

    <div class="column small-12 medium-12 large-7 login-help-content">
      <p>Managers of top-level domains can log in to manage their
        delegation details in the root zone database. This includes
        contact details, name server records and DS records for
        the domain.</p>

      <p><span class="content-header">Forgot your username or password?</span><br/>
        Don't worry, you can recover the <a routerLink="/home/recoverUserName">username</a> or reset the <a routerLink="/home/resetPassword">password</a> online.</p>

      <p><span class="content-header">Delegating a new gTLD?</span><br/>
        <a routerLink="/home/newdelegation">Start the process</a> using your delegation token.</p>
    </div>
  </div>

</div>
</div>
